import React, { useState, useEffect } from "react";
import Search from "./Search";
import * as Icons from "react-feather";
import { useCore } from "store/core";

import { toJalali } from "lib/helpers";
import { Formik, Field, Form } from "formik";
import { TextField, Select, Loading, PersianDataPicker } from "components/form";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { useList } from "store/list";
import { handleSuccessMessages } from "store/auth";
import DirectorReport from "./DirectorReport";
export default function Crm() {
  const core = useCore();

  const [activeTab, setActiveTab] = useState("subscreiption");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showChargeWallet, setShowChargeWallet] = useState(false);
  const [showWithdrawWallet, setShowWithdrawWallet] = useState(false);
  const [showChangeSubscription, setShowChangeSubscription] = useState(false);
  const [showAddSubscription, setShowAddSubscription] = useState(false);
  const [item, setItem] = useState(null);
  const { crmUser } = core;
  const { dispatch, quickUpdate } = useList();
  const path = {
    baseRoute: "/users",
    aliasName: "کاربران",
    type: "Users",
  };
  const __renderTabs = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileTab data={crmUser} />;
      case "wallet":
        return (
          <WalletTab data={crmUser.wallet && crmUser.wallet.transactions} />
        );
      case "tickets":
        return <TicketsTab data={crmUser.tickets} />;
      case "views":
        return <ViewsTab user_id={crmUser.id} />;
      case "orders":
        return <OrdersTab data={crmUser.orders} />;
      case "director-dashboard":
        return <DirectorReport user_id={crmUser.id} />;
      case "subscreiption":
        return (
          <SubscreiptionTab
            setItem={setItem}
            setShowAddSubscription={setShowAddSubscription}
            setShowChangeSubscription={setShowChangeSubscription}
            data={crmUser.subscriptions}
          />
        );
    }
  };
  return (
    <>
      <div className="content">
        <div className="w-full intro-y flex items-center justify-between mt-8">
          <Search />
          <h2 className="text-lg font-medium mr-auto">CRM</h2>
        </div>
        {core.crmLoad && (
          <div className="w-full h-screen-75 flex justify-center items-center">
            <Loading />
          </div>
        )}
        {!crmUser && (
          <div className="w-full h-screen-75 flex justify-center items-center">
            <h2>جستجو کنید و کاربر مورد نظر را انتخاب کنید</h2>
          </div>
        )}
        {crmUser && (
          <>
            <ResetPassword
              id={crmUser.id}
              title="تغییر گذرواژه"
              show={showResetPassword && crmUser.id}
              close={() => {
                setShowResetPassword(false);
              }}
              submite={(values, id) => {
                dispatch(
                  quickUpdate(path, id, values, () => {
                    handleSuccessMessages("گذرواژه تغییر یافت!");
                  })
                );
              }}
            />
            <ChargeWallet
              id={crmUser.id}
              title="شارژ کیف پول"
              show={showChargeWallet && crmUser.id}
              close={() => {
                setShowChargeWallet(false);
              }}
              submite={(values, id) => {
                core.dispatch(
                  core.chargeWallet(id, values, () => {
                    handleSuccessMessages("شارژ کیف پول انجام شد");
                    setShowChargeWallet(false);
                    core.dispatch(core.getCrm(id));
                  })
                );
              }}
            />
            <WithdrawWallet
              id={crmUser.id}
              title="برداشت از کیف پول"
              show={showWithdrawWallet && crmUser.id}
              close={() => {
                setShowWithdrawWallet(false);
              }}
              submite={(values, id) => {
                core.dispatch(
                  core.withdrawWallet(id, values, () => {
                    handleSuccessMessages("برداشت از کیف پول انجام شد");
                    setShowChargeWallet(false);
                    core.dispatch(core.getCrm(id));
                  })
                );
              }}
            />
            <ChangeSubscription
              item={item}
              title="تغییر اشتراک"
              show={showChangeSubscription && crmUser && item}
              close={() => {
                setShowChangeSubscription(false);
              }}
              submite={(values, id) => {
                values.active_to = dateTimeToserver(values.active_to);
                core.dispatch(
                  core.editSubscription(crmUser.id, id, values, () => {
                    handleSuccessMessages("تغییر اشتراک انجام شد");
                    setShowChangeSubscription(false);
                    core.dispatch(core.getCrm(crmUser.id));
                  })
                );
              }}
            />
            <AddSubscription
              title="افزودن اشتراک"
              show={showAddSubscription && crmUser}
              close={() => {
                setShowAddSubscription(false);
              }}
              submite={(values) => {
                values.active_to = dateTimeToserver(values.active_to);
                values.active_from = dateTimeToserver(values.active_from);
                core.dispatch(
                  core.addSubscription(crmUser.id, values, () => {
                    handleSuccessMessages("اشتراک اضافه شد");
                    setShowAddSubscription(false);
                    core.dispatch(core.getCrm(crmUser.id));
                  })
                );
              }}
            />
            <div className="intro-y box px-5 pt-5 mt-5">
              <div className="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5">
                <div className="flex flex-1 px-5 items-center justify-center lg:justify-start">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 flex-none lg:w-32 lg:h-32 image-fit relative">
                    <img
                      className="rounded-full"
                      src="/images-panel/account.jpg"
                    />
                  </div>
                  <div className="mr-5">
                    <div className="w-24 sm:w-40 truncate sm:whitespace-normal font-medium text-lg">
                      {crmUser.full_name}
                    </div>
                    <div className="text-gray-600">{crmUser.user_name}</div>

                    <a
                      className="flex items-center cursor-pointer bg-primary-11 hover:bg-primary-11 justify-center p-1 rounded-sm"
                      onClick={() => {
                        setShowResetPassword(true);
                      }}
                    >
                      {" "}
                      <Icons.Key className="w-4 h-4 ml-1" />
                      تغییر کلمه عبور
                    </a>
                    <a
                      className="mt-2 flex items-center cursor-pointer bg-primary-11 hover:bg-primary-11 justify-center p-1 rounded-sm"
                      onClick={() => {
                        setShowChargeWallet(true);
                      }}
                    >
                      {" "}
                      <Icons.DollarSign className="w-4 h-4 ml-1" />
                      شارژ کیف پول
                    </a>
                    <a
                      className="mt-2 flex items-center cursor-pointer bg-primary-11 hover:bg-primary-11 justify-center p-1 rounded-sm"
                      onClick={() => {
                        setShowWithdrawWallet(true);
                      }}
                    >
                      {" "}
                      <Icons.DollarSign className="w-4 h-4 ml-1" />
                      برداشت از کیف پول
                    </a>
                  </div>
                </div>
                <div className="mt-6 lg:mt-0 flex-1 dark:text-gray-300 px-5 border-l border-r border-gray-200 dark:border-dark-5 border-t lg:border-t-0 pt-5 lg:pt-0">
                  <div className="flex flex-col justify-center items-center lg:items-start mt-4">
                    <div className="truncate sm:whitespace-normal flex items-center">
                      تاریخ ثبت نام:
                      {toJalali(crmUser.created_at, "HH:mm:ss jYYYY/jM/jD")}
                    </div>

                    <div className="truncate sm:whitespace-normal flex items-center">
                      آخرین فعالیت:
                      {crmUser.last_activity
                        ? toJalali(
                            crmUser.last_activity,
                            "HH:mm:ss jYYYY/jM/jD"
                          )
                        : "بدون سابقه ورود به سیستم"}
                    </div>
                    <div className="truncate sm:whitespace-normal flex items-center">
                      موجودی کیف پول(تومان):
                      {crmUser.wallet && crmUser.wallet.balance} تومان{" "}
                    </div>
                    <div className="truncate sm:whitespace-normal flex items-center">
                      موجودی کیف پول(دلار):
                      {crmUser.wallet && crmUser.wallet.usd_balance} دلار{" "}
                    </div>
                  </div>
                </div>
                <div className="mt-6 lg:mt-0 flex-1 flex items-center justify-center px-5 border-t lg:border-0 border-gray-200 dark:border-dark-5 pt-5 lg:pt-0">
                  <div className="text-center rounded-md w-1/2 py-3">
                    <div className="font-medium text-theme-1 dark:text-theme-10 text-xl">
                      {crmUser.orders?.length}
                    </div>
                    <div className="text-gray-600">سفارش ها</div>
                  </div>

                  {/* <div className="text-center rounded-md w-1/2 py-3">
                            <div className="font-medium text-theme-1 dark:text-theme-10 text-xl">492</div>
                            <div className="text-gray-600">فیلم های مشاهده شده</div>
                        </div> */}
                </div>
              </div>

              <div
                className="nav nav-tabs flex-col sm:flex-row justify-center lg:justify-start"
                role="tablist"
              >
                <a
                  id="profile-tab"
                  href="javascript:;"
                  className={`py-4 sm:mr-8 flex items-center ${
                    activeTab == "subscreiption" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("subscreiption");
                  }}
                >
                  <Icons.Package className="ml-2" />
                  اشتراک ها{" "}
                </a>
                <a
                  id="profile-tab"
                  href="javascript:;"
                  className={`py-4 sm:mr-8 flex items-center ${
                    activeTab == "orders" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("orders");
                  }}
                >
                  <Icons.ShoppingCart className="ml-2" />
                  خرید ها{" "}
                </a>
                <a
                  id="profile-tab"
                  href="javascript:;"
                  className={`py-4 sm:mr-8 flex items-center ${
                    activeTab == "tickets" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("tickets");
                  }}
                >
                  <Icons.CreditCard className="ml-2" />
                  بلیت ها{" "}
                </a>
                <a
                  id="profile-tab"
                  href="javascript:;"
                  className={`py-4 sm:mr-8 flex items-center ${
                    activeTab == "wallet" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("wallet");
                  }}
                >
                  <Icons.DollarSign className="ml-2" />
                  کیف پول{" "}
                </a>
                <a
                  id="profile-tab"
                  href="javascript:;"
                  className={`py-4 sm:mr-8 flex items-center ${
                    activeTab == "views" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("views");
                  }}
                >
                  <Icons.Eye className="ml-2" />
                  بازدید ها{" "}
                </a>
                <a
                  id="profile-tab"
                  href="javascript:;"
                  className={`py-4 sm:mr-8 flex items-center ${
                    activeTab == "director-dashboard" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("director-dashboard");
                  }}
                >
                  <Icons.DollarSign className="ml-2" />
                  داشبورد کارگردان{" "}
                </a>
              </div>
            </div>
            {__renderTabs()}
          </>
        )}
      </div>
    </>
  );
}

const SubscreiptionTab = (props) => {
  const {
    data,
    setShowChangeSubscription,
    setShowAddSubscription,
    setItem,
  } = props;
  return (
    <div className="tab-content mt-5">
      <a
        className="w-32 my-2 flex items-center cursor-pointer bg-primary-11 hover:bg-primary-11 justify-center p-1 rounded-sm"
        onClick={() => {
          setShowAddSubscription(true);
        }}
      >
        {" "}
        افزودن اشتراک
      </a>
      <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table className="table table-report -mt-2">
          <thead className="box">
            <tr>
              <th className="whitespace-nowrap text-center">شناسه</th>
              <th className="whitespace-nowrap text-center">نام بسته</th>
              <th className="whitespace-nowrap text-center">فعال از</th>
              <th className="whitespace-nowrap text-center">فعال تا</th>
              <th className="whitespace-nowrap text-center">روز باقی مانده</th>
              <th className="whitespace-nowrap text-center">تاریخ خرید</th>
            </tr>
          </thead>

          {data && !data.length > 0 && (
            <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
          )}
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <tr key={`item_${index}`} className="intro-x">
                  <td className="text-center">{item.id}</td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item?.name}
                    </p>
                  </td>

                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.active_from &&
                        toJalali(item.active_from, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center flex">
                      {item.active_to &&
                        toJalali(item.active_to, "jYYYY-jMM-jDD HH:mm")}

                      <a
                        className="flex items-center mr-2 cursor-pointer"
                        onClick={() => {
                          setItem(item);
                          setShowChangeSubscription(true);
                        }}
                      >
                        <Icons.CheckSquare className="w-4 h-4 mr-1" />
                      </a>
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.remaning_time}
                    </p>
                  </td>
                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {toJalali(item.created_at, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const OrdersTab = (props) => {
  const { data } = props;
  const types = {
    CHARGE_WALLET: "شارژ کیف پول",
    BUY_MOVIE: "خرید فیلم",
    BUY_SCREENING: "خرید بلیت",
    BUY_SCREENING_CAFE: "خرید بلیت کافه",
    SUBSCRIPTION: "خرید اشتراک",
    BUY_PHYSICAL: "خرید از فروشگاه",
    BUY_FESTIVAL: "خرید پکیج جشنواره",
  };
  const status = {
    Success: (
      <span className="bg-theme-9 p-2 rounded text-gray-200 text-sm">موفق</span>
    ),
    Pending: (
      <span className="bg-theme-3 p-2 rounded text-gray-200 text-sm">
        در انتظار پرداخت
      </span>
    ),
    Created: (
      <span className="bg-theme-5 p-2 rounded text-gray-200 text-sm">
        ثبت شده
      </span>
    ),
    Failed: (
      <span className="bg-theme-6 p-2 rounded text-gray-200 text-sm">
        نا موفق
      </span>
    ),
  };
  const gateways = {
    zarinpal: "زرین پال",
    mellat: "ملت",
    pasargad: "پاسارگاد",
    saman: "سامان",
    paypal: "پی پال",
    inappandroid: "پرداخت درون برنامه ای(adnroid)",
    inappios: "پرداخت درون برنامه ای(ios)",
    reseller: "فروشنده",
  };
  const currency = {
    IRR: "تومان",
    USD: "دلار",
  };
  return (
    <div className="tab-content mt-5">
      <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table className="table table-report -mt-2">
          <thead className="box">
            <tr>
              <th className="whitespace-nowrap text-center">فروشنده</th>
              <th className="whitespace-nowrap text-center">تاریخ</th>
              <th className="whitespace-nowrap text-center">شماره فاکتور</th>
              <th className="whitespace-nowrap text-center">شرح خرید</th>
              <th className="whitespace-nowrap text-center">محصول</th>
              <th className="whitespace-nowrap text-center">تعداد</th>
              <th className="text-center">کاربر</th>
              <th className="whitespace-nowrap text-center">مبلغ</th>
              <th className="whitespace-nowrap text-center">تسویه از</th>
              <th className="whitespace-nowrap text-center">وضعیت</th>
            </tr>
          </thead>

          {data && !data.length > 0 && (
            <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
          )}
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <tr key={`item_${index}`} className="intro-x">
                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {item.seller ? item.seller.full_name : "هاشور"}
                    </p>
                  </td>
                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {toJalali(item.created_at, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>

                  <td className="text-center">{item.id}</td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {types[item.type]}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.orderable && item.orderable.detail?.title}
                      {item.orderable && item?.orderable?.name}
                      {item.orderable && item.orderable.title}
                    </p>
                  </td>
                  <td>{item.count}</td>

                  <td>
                    <p className="font-xs  text-center ">
                      {item.user && item.user.full_name}
                      <br />
                      {item.user && item.user.user_name}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.amount} {currency[item.currency]}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.gateway == "reseller" ? (
                        <>فروشنده:{item.amount}</>
                      ) : (
                        <>
                          {item.pga_amount > 0 && (
                            <>
                              {gateways[item.gateway]}:{item.pga_amount} <br />
                            </>
                          )}

                          {item.discount_amount > 0 && (
                            <>
                              {"کد تخفیف"}:{item.discount_amount}
                              <br />
                            </>
                          )}

                          {item.wallet_amount > 0 && (
                            <>
                              {"کیف پول"}:{item.wallet_amount}
                            </>
                          )}
                        </>
                      )}
                    </p>
                  </td>

                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {status[item.status]}
                    </p>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const TicketsTab = (props) => {
  const { data } = props;
  return (
    <div className="tab-content mt-5">
      <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table className="table table-report -mt-2">
          <thead className="box">
            <tr>
              <th className="whitespace-nowrap text-center">شناسه</th>
              <th className="whitespace-nowrap text-center">کد</th>
              <th className="whitespace-nowrap text-center">فیلم</th>
              <th className="whitespace-nowrap text-center">تعداد استفاده</th>
              <th className="whitespace-nowrap text-center">تاریخ انقضا</th>
              <th className="whitespace-nowrap text-center">وضعیت</th>
              <th className="whitespace-nowrap text-center">تاریخ ایجاد</th>
            </tr>
          </thead>

          {data && !data.length > 0 && (
            <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
          )}
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <tr key={`item_${index}`} className="intro-x">
                  <td className="text-center">{item.id}</td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.code}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.product &&
                        item.product.detail &&
                        item.product.detail.title}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.useage_count}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.expire_time &&
                        toJalali(item.expire_time, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.used ? "استفاده شده" : "استفاده نشده"}
                    </p>
                  </td>

                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {toJalali(item.created_at, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const ViewsTab = (props) => {
  const core = useCore();
  const [data, setData] = useState(null);
  useEffect(() => {
    core.dispatch(
      core.getCrmUserViews(props.user_id, (data) => {
        setData(data);
      })
    );
  }, []);
  if (!data) {
    return <Loading />;
  }
  return (
    <div className="tab-content mt-5">
      <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table className="table table-report -mt-2">
          <thead className="box">
            <tr>
              <th className="whitespace-nowrap text-center">شناسه</th>
              <th className="whitespace-nowrap text-center">نام محصول</th>

              <th className="whitespace-nowrap text-center">تاریخ </th>
              <th className="whitespace-nowrap text-center">دستگاه </th>
            </tr>
          </thead>

          {data && !data.length > 0 && (
            <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
          )}
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <tr key={`item_${index}`} className="intro-x">
                  <td className="text-center">
                    {item.viewable && item.viewable.id}
                  </td>

                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.viewable && item.viewable.detail.title}
                    </p>
                  </td>

                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {toJalali(item.viewed_at, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>
                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {item.user_agent}
                    </p>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const WalletTab = (props) => {
  const { data } = props;
  return (
    <div className="tab-content mt-5">
      <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table className="table table-report -mt-2">
          <thead className="box">
            <tr>
              <th className="whitespace-nowrap text-center">شناسه</th>
              <th className="whitespace-nowrap text-center">تراکنش</th>
              <th className="whitespace-nowrap text-center">نوع</th>
              <th className="whitespace-nowrap text-center">ارز</th>
              <th className="whitespace-nowrap text-center">مبلغ</th>
              <th className="whitespace-nowrap text-center">توضیح</th>

              <th className="whitespace-nowrap text-center">تاریخ</th>
            </tr>
          </thead>

          {data && !data.length > 0 && (
            <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
          )}
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((item) => (
                <tr key={`item_${item.id}`} className="intro-x">
                  <td className="text-center">{item.id}</td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.hash}
                    </p>
                  </td>

                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.type == "deposit" ? "شارژ" : "برداشت"}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.currency == "IRR" ? "تومان" : "دلار"}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.amount}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-center">
                      {item.meta && item.meta.desc}
                    </p>
                  </td>

                  <td>
                    <p className="ltr font-medium whitespace-nowrap text-center">
                      {toJalali(item.created_at, "jYYYY-jMM-jDD hh:mm")}
                    </p>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const ProfileTab = () => {
  return (
    <div className="tab-content mt-5">
      <div id="profile" className="tab-pane active" role="tabpanel">
        profile
      </div>
    </div>
  );
};

const ChargeWallet = (props) => {
  const { show, id } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting }) => {
            await props.submite(transformTranslateFromValues(values), id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="ارز"
                    label="ارز :"
                    name="currency"
                    options={[
                      { label: "تومان", value: "IRR" },
                      { label: "دلار", value: "USD" },
                    ]}
                    component={Select}
                  />
                  <Field
                    placeholder="مبلغ"
                    label="مبلغ :"
                    name="amount"
                    type="number"
                    component={TextField}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "شارژ"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};
const WithdrawWallet = (props) => {
  const { show, id } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting }) => {
            await props.submite(transformTranslateFromValues(values), id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="ارز"
                    label="ارز :"
                    name="currency"
                    options={[
                      { label: "تومان", value: "IRR" },
                      { label: "دلار", value: "USD" },
                    ]}
                    component={Select}
                  />
                  <Field
                    placeholder="مبلغ"
                    label="مبلغ :"
                    name="amount"
                    type="number"
                    component={TextField}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "برداشت"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

const ChangeSubscription = (props) => {
  const { show, item } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{ active_to: item && item.active_to }}
          onSubmit={async (values, { setSubmitting }) => {
            await props.submite(
              transformTranslateFromValues(values),
              item && item.id
            );
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="تاریخ انقضا"
                    label="تاریخ انقضا :"
                    name="active_to"
                    hasTime={true}
                    format="YYYY/MM/DD HH:mm:ss"
                    component={PersianDataPicker}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

const AddSubscription = (props) => {
  const { show } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting }) => {
            await props.submite(transformTranslateFromValues(values));
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="تاریخ شروع"
                    label="تاریخ شروع :"
                    name="active_from"
                    hasTime={true}
                    format="YYYY/MM/DD HH:mm:ss"
                    component={PersianDataPicker}
                  />
                  <Field
                    placeholder="تاریخ انقضا"
                    label="تاریخ انقضا :"
                    name="active_to"
                    hasTime={true}
                    format="YYYY/MM/DD HH:mm:ss"
                    component={PersianDataPicker}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

const ResetPassword = (props) => {
  const { show, id } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting }) => {
            await props.submite(transformTranslateFromValues(values), id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="گذرواژه"
                    label="گذرواژه :"
                    name="password"
                    component={TextField}
                    type={"password"}
                  />
                  <Field
                    placeholder="تکرار گذرواژه"
                    label="تکرار گذرواژه :"
                    name="password_confirmation"
                    type={"password"}
                    component={TextField}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};
